import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./mediaCard.html";
/**
 * Data shape for a single media card, mapped onto the `@api` props below.
 */

/**
 * Presentational media card: an optional image beside a copy column
 * (optional category, title, optional subtitle, and an optional "learn more"
 * CTA link). Fluid width — the consumer owns the responsive layout.
 */
class MediaCard extends LightningElement {
  constructor(...args) {
    super(...args);
    this.category = void 0;
    this.title = void 0;
    this.subtitle = void 0;
    this.image = void 0;
    this.callToAction = void 0;
    this.ctaAriaLabel = void 0;
    this.isExternalCta = void 0;
  }
  /**
   * Alt text for the badge/logo image. Falls back to the (required) title so an
   * informative image is never left without a text alternative; a caller that
   * wants the image treated as decorative can pass an explicit empty altText.
   */
  get imageAltText() {
    return this.image?.altText ?? this.title;
  }
  get ctaTarget() {
    return this.isExternalCta ? '_blank' : undefined;
  }
  get ctaRel() {
    return this.isExternalCta ? 'noopener noreferrer' : undefined;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(MediaCard, {
  publicProps: {
    category: {
      config: 0
    },
    title: {
      config: 0
    },
    subtitle: {
      config: 0
    },
    image: {
      config: 0
    },
    callToAction: {
      config: 0
    },
    ctaAriaLabel: {
      config: 0
    },
    isExternalCta: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(MediaCard, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;